import axios from './configObra/config-obra'

const defaultRoute = '/empresa'

export default {
  list: (filter, filial) =>
    axios.get(`${defaultRoute}/byFilter?${filter}=${filial}`),
  findById: (id) => axios.get(`${defaultRoute}/${id}`),
  create: (empresa) => axios.post(defaultRoute, empresa),
  update: (id, empresa) => axios.patch(`${defaultRoute}/${id}`, empresa),
  remove: (id) => axios.delete(`${defaultRoute}/${id}`),
  vincUser: (empresa, user) =>
    axios.patch(`${defaultRoute}/vincularuserempresa/${empresa}`, user),
  desVincUser: (empresa, user) =>
    axios.patch(`${defaultRoute}/desvincularuserempresa/${empresa}`, user),
  detalhesUsuarios: (empresa) =>
    axios.get(`${defaultRoute}/${empresa}/detalhes-usuarios`),
  desativaEmpresa: (empresa, data) =>
    axios.patch(`${defaultRoute}/${empresa}/inativar/`, data),
  ativaEmpresa: (empresa) => axios.patch(`${defaultRoute}/${empresa}/ativar/`),
  listEmpresas: () => axios.get(`${defaultRoute}`),
}
